import React        from "react";
import {render, unmountComponentAtNode}     from 'react-dom';
import Flux         from "../../../../flux/Flux";
import style        from './Tile.module.less';
import Footer       from "./Footer";
import ReloadHelper from "../../../../utils/ReloadHelper";
import AlbumBuyButtons from "../../../ActorProfile/ActorProfileVideos/AlbumBuyButtons";

const expandDesktop = (props) => {
    const {id, model, title, description, linkVX, tileRef, config, displayConfig, children} = props;
    const index             = config.index + 1;
    const columnsPerRow     = displayConfig.columns.values[Flux.Browser.getViewPort()];
    const grid              = tileRef.current.closest('.grid-2');
    grid.style.gridAutoFlow = "row dense";

    const placeholder            = document.createElement('div');
    placeholder.style.gridRow    = (Math.ceil(index / columnsPerRow) + 1).toString();
    placeholder.style.gridColumn = '1/' + (columnsPerRow + 1);
    placeholder.classList.add('grid-2__item');
    placeholder.classList.add('placeholder--' + id);
    const placeholderTile = <div className={style.tile + " " + style.tileShow}>
        <div className={style.tileBody}>
            {children}
        </div>
        <Footer model={model} linkVX={linkVX} title={title} description={description} isExpand={config.isExpand}/>
    </div>;
    render(placeholderTile, placeholder);
    grid.appendChild(placeholder);
    setTimeout(() => {
        placeholder.scrollIntoView({block: "center", behavior: "smooth"});
    }, 50);
};

const closeDesktop = (id) => {
    const placeholder = document.querySelector('.grid-2__item.placeholder--' + id);
    placeholder && unmountComponentAtNode(placeholder);
    placeholder?.remove();
};

const onClickProfile = (e, linkVX) => {
    e.preventDefault();
    e.stopPropagation();
    linkVX && ReloadHelper.reload(linkVX);
};

/**
 * @param {object} model
 */
const modelAvatar = (model) => (
        model?.name && <a href={model?.linkVX} className={style.tileModel} onClick={(e) => onClickProfile(e, model?.linkVX)}>
        {model?.name && <div className={style.tileModelName}>{model?.name}</div>}
    </a>
);

const getBuyButton = (data, config, needAvsButton, showDailyBonusBadge = true) => {

    if (!data.id || !data.model || (data.guestInfo?.bought && !needAvsButton) || !data.price) {
        return null;
    }

    return <AlbumBuyButtons actorDataId={data.model.id}
                                     isAlbumBought={data.guestInfo?.bought}
                                     additionalClasses = {config.additionalClasses || ""}
                                     baseClassName="vx_shaka--ui--no-margin-mobile vx_shaka--ui"
                                     //isFromCurrentVideoContest={this.props.mediaElement && this.props.mediaElement.contestId > 0}
                                     needVip={data.vip}
                                     //hasActiveDiscount={currentVideo.hasActiveDiscount}
                                     //isAccessAllowed={currentVideo.isAccessAllowed}
                                     //needPayment={currentVideo.needPayment}
                                     needBuying={!data.guestInfo?.bought}
                                     needAvs={!Flux.Guest.hasAvs() && data.ageRating === 18}
                                     price={data.price.value}
                                     showDailyBonusBadge={showDailyBonusBadge}
                                     //crossPrice={currentVideo.crossPrice}
                                     voucherPrice={data.price.currency === 'Voucher' ? data.price.value : null}
                                     id={data.id}
                                     //contestLink={currentVideo.contestLink}
                                     //isVip30={currentVideo.isVip30}
                                     canBuy={true}
                                     //hasComment={currentVideo.hasComment}
                                     onBuyModalId={""}
                                     //showSignupButton={this.props.showSignupButton}
                                     //vxbuttonAdditionalStyle={this.props.vxbuttonAdditionalStyle}
                                     onBuySuccess={config.onBuy}
                                     sticky={false}
    />;
};

export {
    expandDesktop,
    closeDesktop,
    onClickProfile,
    modelAvatar,
    getBuyButton
};
